import React, { useEffect } from 'react'
import './style.css'
import AOS from "aos";
import "aos/dist/aos.css";

const UperFooter = ({data}) => {

  useEffect(() => {
    AOS.init({ duration: 1500 });
  });

  return (
    <div className='py-5'>
        <div className='col-11 col-lg-8 m-auto p-4 py-5 uperFooterCircle text-center' data-aos="zoom-in-up">
            <p className='fs-2 text-dark mb-4 fw-bold'>Want to know more?</p>
            <div className='buttonDiv m-auto' onClick={()=>data(true)}>
                <div className='button'>Register With Us</div>
                <div className='button-clip'>Register With Us</div>  
            </div>
        </div>
    </div>
  )
}

export default UperFooter